import React, { useEffect, useState } from 'react';

// URL base del servidor (misma constante que en NexusAIWebsite.jsx)
const API_URL = 'https://api.nexusai.company';

// Mapa product_key -> vista de navegación interna (misma convención que handleManageProduct)
const VIEW_FOR = {
  nexusstock: 'stock',
  nexuscaja: 'caja',
  nexuscommerce: 'nexuscommerce',
  nexusmessages: 'messages',
  nexusorders: 'orders',
  gestorclientes: 'gestorclientes'
};

const viewFor = (productKey) => VIEW_FOR[productKey] || productKey;

/**
 * Banner de resumen del Motor de Onboarding IA.
 * Muestra lo que el motor cargó solo desde la web del cliente (por producto).
 * Se degrada a `null` (no renderiza nada) si el endpoint falla, no responde,
 * o no hay nada relevante que mostrar todavía.
 */
const OnboardingSummary = (props) => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);

  useEffect(() => {
    let cancelled = false;

    const load = async () => {
      try {
        const token = localStorage.getItem('nexusai-token');
        const res = await fetch(`${API_URL}/api/onboarding/summary`, {
          headers: { Authorization: 'Bearer ' + token }
        });

        if (!res.ok) {
          if (!cancelled) { setData(null); setLoading(false); }
          return;
        }

        const json = await res.json();
        if (!cancelled) {
          setData(json && json.success ? json.data : null);
          setLoading(false);
        }
      } catch (err) {
        // Best-effort: si el endpoint no existe aún o falla, degradar en silencio
        if (!cancelled) { setData(null); setLoading(false); }
      }
    };

    load();
    return () => { cancelled = true; };
  }, []);

  if (loading) return null;
  if (!data || !data.profile) return null;

  const items = data.items || [];
  const readyItems = items.filter((i) => i.ready);
  if (readyItems.length === 0) return null;

  const { profile } = data;

  return (
    <div
      data-fallable="true"
      className="bg-gradient-to-r from-emerald-50 via-teal-50 to-indigo-50 border border-emerald-100 rounded-2xl p-6 mb-8 shadow-lg"
    >
      <div className="flex items-start gap-3 mb-4">
        <span className="text-3xl leading-none">🎉</span>
        <div>
          <h3 className="text-lg font-bold text-gray-900">
            Ya preparamos tu negocio
          </h3>
          <p className="text-sm text-gray-600">
            Cargamos esto automáticamente desde{' '}
            <strong>{profile.business_name}</strong>
            {profile.domain ? ` (${profile.domain})` : ''}. Revísalo y ajústalo cuando quieras.
          </p>
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        {readyItems.map((item) => (
          <div
            key={item.product_key}
            className="bg-white/80 backdrop-blur-sm rounded-xl p-4 flex items-center justify-between gap-3 shadow-sm"
          >
            <div className="min-w-0">
              <p className="font-bold text-gray-900 truncate">{item.label}</p>
              {item.detail && (
                <p className="text-sm text-gray-500 truncate">{item.detail}</p>
              )}
            </div>
            <button
              onClick={() => props.onNavigate && props.onNavigate(viewFor(item.product_key))}
              className="flex-shrink-0 whitespace-nowrap px-3 py-1.5 rounded-md text-sm font-medium bg-indigo-600 text-white hover:bg-indigo-700 transition-colors"
            >
              Revisar
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default OnboardingSummary;
